import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    ad: {
      marginInline: 'auto',
      width: 'fit-content',
    },
  },
  { name: 'googleAd' },
);

export default useStyles;
